import { axiosInstance } from "./axiosInstance";

export const PrivateServices = {
    getAll: async (filter) => {
        return await axiosInstance.get("/api/feature/class/schedule/private/admin", { params: filter });
    },
    update: async (id, data) => {
        return await axiosInstance.post(`/api/feature/class/schedule/private/admin/update/${id}`, data);
    }
};